import {
  Badge,
  Box,
  Button,
  Code,
  Flex,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaPowerOff } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import { toast } from "react-toastify";
import apiClient from "../../../utils/ApiClient/apiClientAxios";

const OrchestrationStatusCard = ({ data }) => {
  const codeBg = useColorModeValue("gray.100", "gray.700");
  const cardBg = useColorModeValue("white", "gray.800");
  const [terminating, setTerminating] = useState(false);
  const [checking, setChecking] = useState(false);
  const [caseProcessStatus, setCaseProcessStatus] = useState();

  const createdDate = data.created_at
    ? new Date(parseInt(data.created_at, 10) * 1000).toLocaleString()
    : "-";
  const formattedRules = (() => {
    try {
      return JSON.stringify(data.rules, null, 2);
    } catch {
      return "-";
    }
  })();

  // 🔴 Terminate process (PUT)
  const handleTerminate = async () => {
    if (!data.id) {
      toast.error("Cannot terminate without a valid ID.");
      return;
    }

    try {
      setTerminating(true);
      const response = await apiClient.put(
        `/caseProcessor?id=${encodeURIComponent(data.id)}`
      );
      toast.success(
        response.data?.message || "Termination request sent successfully."
      );
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "An error occurred while terminating the process."
      );
    } finally {
      setTerminating(false);
    }
  };

  // 🔵 Check status (GET)
  const handleCheckStatus = async () => {
    if (!data.id) {
      toast.error("Cannot check status without a valid ID.");
      return;
    }

    try {
      setChecking(true);
      const response = await apiClient.get(
        `/caseProcessor?id=${encodeURIComponent(data.id)}`
      );
      const status = response.data?.runtimeStatus || "Unknown";
      toast.info(`Runtime Status: ${status}`);
      setCaseProcessStatus(status);
    } catch (error) {
      console.log(
        error.response?.data?.message ||
          error.message ||
          "An error occurred while checking status."
      );
    } finally {
      setChecking(false);
    }
  };
  const getStatusColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "completed":
        return "green";
      case "failed":
        return "red";
      case "running":
        return "yellow";
      case "pending":
        return "blue";
      default:
        return "gray";
    }
  };

  console.log("===data", data);

  if (!data) return null;

  return (
    <Box
      fontFamily="monospace"
      textAlign="left"
      borderWidth="1px"
      borderRadius="md"
      p={4}
      bg={cardBg}
      boxShadow="md"
      w="100%"
    >
      <VStack align="start" spacing={2}>
        <Text>
          <b>ID:</b> {data.id || "-"}
        </Text>

        <Text whiteSpace="pre-wrap">
          <b>Query:</b> {data.query || "-"}
        </Text>

        <Text>
          <b>Created At:</b> {createdDate}
        </Text>
        <Text>
          <b>Cases Processed:</b> {data?.process_number || "-"}
        </Text>

        <Box h={3} />

        <Flex align="center" gap={3}>
          <Text fontWeight="bold">Status:</Text>
          <Badge colorScheme={getStatusColor(caseProcessStatus)}>
            {caseProcessStatus || "-"}
          </Badge>
          <Button
            size="sm"
            colorScheme="blue"
            leftIcon={<FiRefreshCcw size={16} />}
            isLoading={checking}
            onClick={handleCheckStatus}
          >
            Check Status
          </Button>
        </Flex>

        {/* Terminate Process */}
        <Flex align="center" gap={3} mt={2}>
          <Text fontWeight="bold">Kill URL:</Text>
          <Button
            size="sm"
            colorScheme="red"
            leftIcon={<FaPowerOff size={16} />}
            isLoading={terminating}
            onClick={handleTerminate}
          >
            Terminate Process
          </Button>
        </Flex>

        <Box h={3} />
        <Text>
          <b>Rules:</b>
        </Text>
        <Box
          bg={codeBg}
          p={2}
          borderRadius="md"
          overflowY="auto"
          maxH="300px"
          width="100%"
        >
          <Code whiteSpace="pre" width="100%">
            {formattedRules}
          </Code>
        </Box>
      </VStack>
    </Box>
  );
};

export default OrchestrationStatusCard;
